/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const SummarySection = core.serialization.object({
    total: core.serialization.number(),
    byField: core.serialization.record(core.serialization.string(), core.serialization.number()).optional(),
});
